/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { CredentialErrors, Credential } from 'cio/utils/in-app/credentials';

interface GistAuthorizationFormArgs {
  organizationId: string;
  credential: Credential;
  errors: CredentialErrors;
  configureGistTask: Task<unknown, [string, string]>;
  disableGistTask: Task<void, []>;
}

export default class GistAuthorizationForm extends Component<GistAuthorizationFormArgs> {}
